import { useState } from 'react';

import { ReportDialog } from '../moderation/ReportDialog';
import { useSession } from '../../stores/session';
import type { Profile } from './types';

/**
 * Reporting a whole account.
 *
 * ## Why it sits beside Block
 *
 * They are the two things somebody reaches for in the same moment: one stops it
 * reaching them, the other tells somebody about it. Putting the report in a
 * menu makes the person who most needs it hunt for it.
 *
 * ## Signed in only, and never your own
 *
 * A signed-out reader has nothing to report *with* - the endpoint needs to know
 * who filed it - and reporting yourself is not a thing anybody means to do.
 */
export function ReportAccount({ profile }: { profile: Profile }) {
  const me = useSession((state) => state.user);
  const [open, setOpen] = useState(false);

  if (!me || me.username === profile.username) return null;

  return (
    <>
      <button
        type="button"
        data-report-account={profile.username}
        onClick={() => setOpen(true)}
        className="meta-caps text-faint transition-colors hover:text-hot-text"
      >
        Report
      </button>

      {open && (
        <ReportDialog
          subjectType="user"
          subjectId={profile.id}
          title={profile.display_name || profile.username}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
